import { Logo } from "./Logo";

const LINKS = [
    { id: "home", label: "Home", testId: "footer-nav-home" },
    { id: "what-we-do", label: "What We Do", testId: "footer-nav-what-we-do" },
    { id: "why-a-website", label: "Why A Website", testId: "footer-nav-why-a-website" },
    { id: "contact", label: "Contact", testId: "footer-nav-contact" },
];

export const Footer = ({ onNavigate }) => (
    <footer
        data-testid="site-footer"
        className="bg-zinc-950 border-t border-zinc-800/80 py-12"
    >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-8">
            <div>
                <Logo inverted />
                <p className="mt-3 text-sm text-zinc-500">
                    Modern Websites. Built for Business.
                </p>
            </div>
            <nav className="flex flex-wrap gap-x-7 gap-y-3">
                {LINKS.map((l) => (
                    <button
                        key={l.id}
                        data-testid={l.testId}
                        onClick={() => onNavigate(`#${l.id}`)}
                        className="text-sm text-zinc-400 hover:text-blue-500 transition-colors duration-200"
                    >
                        {l.label}
                    </button>
                ))}
            </nav>
        </div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-10 pt-6 border-t border-zinc-900">
            <p className="font-mono-label text-xs text-zinc-600 tracking-wide">
                © {new Date().getFullYear()} Emira Digital — United Kingdom
            </p>
        </div>
    </footer>
);
